// 🔴 GENERATED BY scripts/k3d/build_k3d_questions.py — DO NOT EDIT.
// Every rule V2-V6 passed before this file was written. Edit the
// generator and re-run; a hand edit here is invisible to validation.
import type { Item } from "./types";

export const K3D_ITEMS: Item[] = [
  {
    id: "k3d.obj.hat",
    band: "BAND_3_4",
    prompt: { en: "Where is the hat?" },
    label: "hat",
    audioKey: "k3d.where_is_the_hat",
    target: "hat",
    choices: ["hat", "bag", "cake"],
    asset: "hat",
  },
  {
    id: "k3d.obj.cap",
    band: "BAND_3_4",
    prompt: { en: "Where is the cap?" },
    label: "cap",
    audioKey: "k3d.where_is_the_cap",
    target: "cap",
    choices: ["cap", "bag", "cake"],
    asset: "cap",
  },
  {
    id: "k3d.obj.bag",
    band: "BAND_3_4",
    prompt: { en: "Where is the bag?" },
    label: "bag",
    audioKey: "k3d.where_is_the_bag",
    target: "bag",
    choices: ["bag", "cake", "sun"],
    asset: "bag",
  },
  {
    id: "k3d.obj.cake",
    band: "BAND_3_4",
    prompt: { en: "Where is the cake?" },
    label: "cake",
    audioKey: "k3d.where_is_the_cake",
    target: "cake",
    choices: ["cake", "sun", "bell"],
    asset: "cake",
  },
  {
    id: "k3d.obj.sun",
    band: "BAND_3_4",
    prompt: { en: "Where is the sun?" },
    label: "sun",
    audioKey: "k3d.where_is_the_sun",
    target: "sun",
    choices: ["sun", "bell", "plate"],
    asset: "sun",
  },
  {
    id: "k3d.obj.bell",
    band: "BAND_3_4",
    prompt: { en: "Where is the bell?" },
    label: "bell",
    audioKey: "k3d.where_is_the_bell",
    target: "bell",
    choices: ["bell", "plate", "fan"],
    asset: "bell",
  },
  {
    id: "k3d.obj.plate",
    band: "BAND_3_4",
    prompt: { en: "Where is the plate?" },
    label: "plate",
    audioKey: "k3d.where_is_the_plate",
    target: "plate",
    choices: ["plate", "fan", "drum"],
    asset: "plate",
  },
  {
    id: "k3d.obj.fan",
    band: "BAND_3_4",
    prompt: { en: "Where is the fan?" },
    label: "fan",
    audioKey: "k3d.where_is_the_fan",
    target: "fan",
    choices: ["fan", "drum", "top"],
    asset: "fan",
  },
  {
    id: "k3d.obj.drum",
    band: "BAND_3_4",
    prompt: { en: "Where is the drum?" },
    label: "drum",
    audioKey: "k3d.where_is_the_drum",
    target: "drum",
    choices: ["drum", "top", "ring"],
    asset: "drum",
  },
  {
    id: "k3d.obj.top",
    band: "BAND_3_4",
    prompt: { en: "Where is the top?" },
    label: "top",
    audioKey: "k3d.where_is_the_top",
    target: "top",
    choices: ["top", "ring", "hat"],
    asset: "top",
  },
  {
    id: "k3d.obj.ring",
    band: "BAND_3_4",
    prompt: { en: "Where is the ring?" },
    label: "ring",
    audioKey: "k3d.where_is_the_ring",
    target: "ring",
    choices: ["ring", "hat", "bag"],
    asset: "ring",
  },
  {
    id: "k3d.obj.red.ball",
    band: "BAND_3_4",
    prompt: { en: "Where is the ball?" },
    label: "ball",
    audioKey: "k3d.where_is_the_ball",
    target: "red-ball",
    choices: ["red-ball", "red-car", "red-flower"],
    asset: "red-ball",
  },
  {
    id: "k3d.obj.red.car",
    band: "BAND_3_4",
    prompt: { en: "Where is the car?" },
    label: "car",
    audioKey: "k3d.where_is_the_car",
    target: "red-car",
    choices: ["red-car", "red-flower", "red-balloon"],
    asset: "red-car",
  },
  {
    id: "k3d.obj.red.flower",
    band: "BAND_3_4",
    prompt: { en: "Where is the flower?" },
    label: "flower",
    audioKey: "k3d.where_is_the_flower",
    target: "red-flower",
    choices: ["red-flower", "red-balloon", "red-car"],
    asset: "red-flower",
  },
  {
    id: "k3d.obj.red.balloon",
    band: "BAND_3_4",
    prompt: { en: "Where is the balloon?" },
    label: "balloon",
    audioKey: "k3d.where_is_the_balloon",
    target: "red-balloon",
    choices: ["red-balloon", "red-car", "red-flower"],
    asset: "red-balloon",
  },
  {
    id: "k3d.animal.cow",
    band: "BAND_3_4",
    prompt: { en: "Where is the cow?" },
    label: "cow",
    audioKey: "k3d.where_is_the_cow",
    target: "cow",
    choices: ["cow", "dog", "cat"],
    asset: "cow",
  },
  {
    id: "k3d.animal.dog",
    band: "BAND_3_4",
    prompt: { en: "Where is the dog?" },
    label: "dog",
    audioKey: "k3d.where_is_the_dog",
    target: "dog",
    choices: ["dog", "cat", "duck"],
    asset: "dog",
  },
  {
    id: "k3d.animal.cat",
    band: "BAND_3_4",
    prompt: { en: "Where is the cat?" },
    label: "cat",
    audioKey: "k3d.where_is_the_cat",
    target: "cat",
    choices: ["cat", "duck", "sheep"],
    asset: "cat",
  },
  {
    id: "k3d.animal.duck",
    band: "BAND_3_4",
    prompt: { en: "Where is the duck?" },
    label: "duck",
    audioKey: "k3d.where_is_the_duck",
    target: "duck",
    choices: ["duck", "sheep", "pig"],
    asset: "duck",
  },
  {
    id: "k3d.animal.sheep",
    band: "BAND_3_4",
    prompt: { en: "Where is the sheep?" },
    label: "sheep",
    audioKey: "k3d.where_is_the_sheep",
    target: "sheep",
    choices: ["sheep", "pig", "frog"],
    asset: "sheep",
  },
  {
    id: "k3d.animal.pig",
    band: "BAND_3_4",
    prompt: { en: "Where is the pig?" },
    label: "pig",
    audioKey: "k3d.where_is_the_pig",
    target: "pig",
    choices: ["pig", "frog", "hen"],
    asset: "pig",
  },
  {
    id: "k3d.animal.frog",
    band: "BAND_3_4",
    prompt: { en: "Where is the frog?" },
    label: "frog",
    audioKey: "k3d.where_is_the_frog",
    target: "frog",
    choices: ["frog", "hen", "cow"],
    asset: "frog",
  },
  {
    id: "k3d.animal.hen",
    band: "BAND_3_4",
    prompt: { en: "Where is the hen?" },
    label: "hen",
    audioKey: "k3d.where_is_the_hen",
    target: "hen",
    choices: ["hen", "cow", "dog"],
    asset: "hen",
  },
  {
    id: "k3d.col.red.balloon",
    band: "BAND_3_4",
    prompt: { en: "Where is the red balloon?" },
    label: "red balloon",
    audioKey: "k3d.where_is_the_red_balloon",
    target: "red-balloon",
    choices: ["red-balloon", "blue-balloon", "yellow-balloon"],
    asset: "red-balloon",
  },
  {
    id: "k3d.col.red.ball",
    band: "BAND_3_4",
    prompt: { en: "Where is the red ball?" },
    label: "red ball",
    audioKey: "k3d.where_is_the_red_ball",
    target: "red-ball",
    choices: ["red-ball", "blue-ball", "yellow-ball"],
    asset: "red-ball",
  },
  {
    id: "k3d.col.blue.balloon",
    band: "BAND_3_4",
    prompt: { en: "Where is the blue balloon?" },
    label: "blue balloon",
    audioKey: "k3d.where_is_the_blue_balloon",
    target: "blue-balloon",
    choices: ["blue-balloon", "red-balloon", "yellow-balloon"],
    asset: "blue-balloon",
  },
  {
    id: "k3d.col.blue.ball",
    band: "BAND_3_4",
    prompt: { en: "Where is the blue ball?" },
    label: "blue ball",
    audioKey: "k3d.where_is_the_blue_ball",
    target: "blue-ball",
    choices: ["blue-ball", "red-ball", "yellow-ball"],
    asset: "blue-ball",
  },
  {
    id: "k3d.col.yellow.balloon",
    band: "BAND_3_4",
    prompt: { en: "Where is the yellow balloon?" },
    label: "yellow balloon",
    audioKey: "k3d.where_is_the_yellow_balloon",
    target: "yellow-balloon",
    choices: ["yellow-balloon", "red-balloon", "blue-balloon"],
    asset: "yellow-balloon",
  },
  {
    id: "k3d.col.yellow.ball",
    band: "BAND_3_4",
    prompt: { en: "Where is the yellow ball?" },
    label: "yellow ball",
    audioKey: "k3d.where_is_the_yellow_ball",
    target: "yellow-ball",
    choices: ["yellow-ball", "red-ball", "blue-ball"],
    asset: "yellow-ball",
  },
  {
    id: "k3d.col.green.balloon",
    band: "BAND_3_4",
    prompt: { en: "Where is the green balloon?" },
    label: "green balloon",
    audioKey: "k3d.where_is_the_green_balloon",
    target: "green-balloon",
    choices: ["green-balloon", "red-balloon", "blue-balloon"],
    asset: "green-balloon",
  },
  {
    id: "k3d.col.green.ball",
    band: "BAND_3_4",
    prompt: { en: "Where is the green ball?" },
    label: "green ball",
    audioKey: "k3d.where_is_the_green_ball",
    target: "green-ball",
    choices: ["green-ball", "red-ball", "blue-ball"],
    asset: "green-ball",
  },
  {
    id: "k3d.shape.circle",
    band: "BAND_3_4",
    prompt: { en: "Where is the circle?" },
    label: "circle",
    audioKey: "k3d.where_is_the_circle",
    target: "circle",
    choices: ["circle", "square", "triangle"],
    asset: "circle",
  },
  {
    id: "k3d.shape.square",
    band: "BAND_3_4",
    prompt: { en: "Where is the square?" },
    label: "square",
    audioKey: "k3d.where_is_the_square",
    target: "square",
    choices: ["square", "triangle", "star"],
    asset: "square",
  },
  {
    id: "k3d.shape.triangle",
    band: "BAND_3_4",
    prompt: { en: "Where is the triangle?" },
    label: "triangle",
    audioKey: "k3d.where_is_the_triangle",
    target: "triangle",
    choices: ["triangle", "rectangle", "star"],
    asset: "triangle",
  },
  {
    id: "k3d.obj.van",
    band: "BAND_4_5",
    prompt: { en: "Where is the van?" },
    label: "van",
    audioKey: "k3d.where_is_the_van",
    target: "van",
    choices: ["van", "jug", "pan"],
    asset: "van",
  },
  {
    id: "k3d.obj.jug",
    band: "BAND_4_5",
    prompt: { en: "Where is the jug?" },
    label: "jug",
    audioKey: "k3d.where_is_the_jug",
    target: "jug",
    choices: ["jug", "pan", "mop"],
    asset: "jug",
  },
  {
    id: "k3d.obj.pan",
    band: "BAND_4_5",
    prompt: { en: "Where is the pan?" },
    label: "pan",
    audioKey: "k3d.where_is_the_pan",
    target: "pan",
    choices: ["pan", "mop", "map"],
    asset: "pan",
  },
  {
    id: "k3d.obj.mop",
    band: "BAND_4_5",
    prompt: { en: "Where is the mop?" },
    label: "mop",
    audioKey: "k3d.where_is_the_mop",
    target: "mop",
    choices: ["mop", "map", "swing"],
    asset: "mop",
  },
  {
    id: "k3d.obj.map",
    band: "BAND_4_5",
    prompt: { en: "Where is the map?" },
    label: "map",
    audioKey: "k3d.where_is_the_map",
    target: "map",
    choices: ["map", "swing", "shell"],
    asset: "map",
  },
  {
    id: "k3d.obj.mat",
    band: "BAND_4_5",
    prompt: { en: "Where is the mat?" },
    label: "mat",
    audioKey: "k3d.where_is_the_mat",
    target: "mat",
    choices: ["mat", "swing", "shell"],
    asset: "mat",
  },
  {
    id: "k3d.obj.swing",
    band: "BAND_4_5",
    prompt: { en: "Where is the swing?" },
    label: "swing",
    audioKey: "k3d.where_is_the_swing",
    target: "swing",
    choices: ["swing", "shell", "bun"],
    asset: "swing",
  },
  {
    id: "k3d.obj.shell",
    band: "BAND_4_5",
    prompt: { en: "Where is the shell?" },
    label: "shell",
    audioKey: "k3d.where_is_the_shell",
    target: "shell",
    choices: ["shell", "bun", "can"],
    asset: "shell",
  },
  {
    id: "k3d.obj.bun",
    band: "BAND_4_5",
    prompt: { en: "Where is the bun?" },
    label: "bun",
    audioKey: "k3d.where_is_the_bun",
    target: "bun",
    choices: ["bun", "can", "van"],
    asset: "bun",
  },
  {
    id: "k3d.obj.can",
    band: "BAND_4_5",
    prompt: { en: "Where is the can?" },
    label: "can",
    audioKey: "k3d.where_is_the_can",
    target: "can",
    choices: ["can", "van", "pan"],
    asset: "can",
  },
  {
    id: "k3d.obj.blue.butterfly",
    band: "BAND_4_5",
    prompt: { en: "Where is the butterfly?" },
    label: "butterfly",
    audioKey: "k3d.where_is_the_butterfly",
    target: "blue-butterfly",
    choices: ["blue-butterfly", "blue-block", "blue-car"],
    asset: "blue-butterfly",
  },
  {
    id: "k3d.obj.blue.block",
    band: "BAND_4_5",
    prompt: { en: "Where is the block?" },
    label: "block",
    audioKey: "k3d.where_is_the_block",
    target: "blue-block",
    choices: ["blue-block", "blue-car", "blue-flower"],
    asset: "blue-block",
  },
  {
    id: "k3d.obj.blue.car",
    band: "BAND_4_5",
    prompt: { en: "Where is the car?" },
    label: "car",
    audioKey: "k3d.where_is_the_car",
    target: "blue-car",
    choices: ["blue-car", "blue-flower", "blue-butterfly"],
    asset: "blue-car",
  },
  {
    id: "k3d.obj.blue.flower",
    band: "BAND_4_5",
    prompt: { en: "Where is the flower?" },
    label: "flower",
    audioKey: "k3d.where_is_the_flower",
    target: "blue-flower",
    choices: ["blue-flower", "blue-butterfly", "blue-block"],
    asset: "blue-flower",
  },
  {
    id: "k3d.animal.horse",
    band: "BAND_4_5",
    prompt: { en: "Where is the horse?" },
    label: "horse",
    audioKey: "k3d.where_is_the_horse",
    target: "horse",
    choices: ["horse", "lion", "bird"],
    asset: "horse",
  },
  {
    id: "k3d.animal.lion",
    band: "BAND_4_5",
    prompt: { en: "Where is the lion?" },
    label: "lion",
    audioKey: "k3d.where_is_the_lion",
    target: "lion",
    choices: ["lion", "bird", "bee"],
    asset: "lion",
  },
  {
    id: "k3d.animal.bird",
    band: "BAND_4_5",
    prompt: { en: "Where is the bird?" },
    label: "bird",
    audioKey: "k3d.where_is_the_bird",
    target: "bird",
    choices: ["bird", "bee", "goat"],
    asset: "bird",
  },
  {
    id: "k3d.animal.bee",
    band: "BAND_4_5",
    prompt: { en: "Where is the bee?" },
    label: "bee",
    audioKey: "k3d.where_is_the_bee",
    target: "bee",
    choices: ["bee", "goat", "donkey"],
    asset: "bee",
  },
  {
    id: "k3d.animal.goat",
    band: "BAND_4_5",
    prompt: { en: "Where is the goat?" },
    label: "goat",
    audioKey: "k3d.where_is_the_goat",
    target: "goat",
    choices: ["goat", "donkey", "elephant"],
    asset: "goat",
  },
  {
    id: "k3d.animal.donkey",
    band: "BAND_4_5",
    prompt: { en: "Where is the donkey?" },
    label: "donkey",
    audioKey: "k3d.where_is_the_donkey",
    target: "donkey",
    choices: ["donkey", "elephant", "lion"],
    asset: "donkey",
  },
  {
    id: "k3d.animal.elephant",
    band: "BAND_4_5",
    prompt: { en: "Where is the elephant?" },
    label: "elephant",
    audioKey: "k3d.where_is_the_elephant",
    target: "elephant",
    choices: ["elephant", "horse", "lion"],
    asset: "elephant",
  },
  {
    id: "k3d.col.orange.balloon",
    band: "BAND_4_5",
    prompt: { en: "Where is the orange balloon?" },
    label: "orange balloon",
    audioKey: "k3d.where_is_the_orange_balloon",
    target: "orange-balloon",
    choices: ["orange-balloon", "purple-balloon", "pink-balloon"],
    asset: "orange-balloon",
  },
  {
    id: "k3d.col.orange.ball",
    band: "BAND_4_5",
    prompt: { en: "Where is the orange ball?" },
    label: "orange ball",
    audioKey: "k3d.where_is_the_orange_ball",
    target: "orange-ball",
    choices: ["orange-ball", "purple-ball", "pink-ball"],
    asset: "orange-ball",
  },
  {
    id: "k3d.col.purple.balloon",
    band: "BAND_4_5",
    prompt: { en: "Where is the purple balloon?" },
    label: "purple balloon",
    audioKey: "k3d.where_is_the_purple_balloon",
    target: "purple-balloon",
    choices: ["purple-balloon", "orange-balloon", "pink-balloon"],
    asset: "purple-balloon",
  },
  {
    id: "k3d.col.purple.ball",
    band: "BAND_4_5",
    prompt: { en: "Where is the purple ball?" },
    label: "purple ball",
    audioKey: "k3d.where_is_the_purple_ball",
    target: "purple-ball",
    choices: ["purple-ball", "orange-ball", "pink-ball"],
    asset: "purple-ball",
  },
  {
    id: "k3d.col.pink.balloon",
    band: "BAND_4_5",
    prompt: { en: "Where is the pink balloon?" },
    label: "pink balloon",
    audioKey: "k3d.where_is_the_pink_balloon",
    target: "pink-balloon",
    choices: ["pink-balloon", "orange-balloon", "purple-balloon"],
    asset: "pink-balloon",
  },
  {
    id: "k3d.col.pink.ball",
    band: "BAND_4_5",
    prompt: { en: "Where is the pink ball?" },
    label: "pink ball",
    audioKey: "k3d.where_is_the_pink_ball",
    target: "pink-ball",
    choices: ["pink-ball", "orange-ball", "purple-ball"],
    asset: "pink-ball",
  },
  {
    id: "k3d.col.brown.balloon",
    band: "BAND_4_5",
    prompt: { en: "Where is the brown balloon?" },
    label: "brown balloon",
    audioKey: "k3d.where_is_the_brown_balloon",
    target: "brown-balloon",
    choices: ["brown-balloon", "orange-balloon", "purple-balloon"],
    asset: "brown-balloon",
  },
  {
    id: "k3d.col.brown.ball",
    band: "BAND_4_5",
    prompt: { en: "Where is the brown ball?" },
    label: "brown ball",
    audioKey: "k3d.where_is_the_brown_ball",
    target: "brown-ball",
    choices: ["brown-ball", "orange-ball", "purple-ball"],
    asset: "brown-ball",
  },
  {
    id: "k3d.obj.rake",
    band: "BAND_5_6",
    prompt: { en: "Where is the rake?" },
    label: "rake",
    audioKey: "k3d.where_is_the_rake",
    target: "rake",
    choices: ["rake", "well", "wig"],
    asset: "rake",
  },
  {
    id: "k3d.obj.well",
    band: "BAND_5_6",
    prompt: { en: "Where is the well?" },
    label: "well",
    audioKey: "k3d.where_is_the_well",
    target: "well",
    choices: ["well", "wig", "log"],
    asset: "well",
  },
  {
    id: "k3d.obj.wig",
    band: "BAND_5_6",
    prompt: { en: "Where is the wig?" },
    label: "wig",
    audioKey: "k3d.where_is_the_wig",
    target: "wig",
    choices: ["wig", "log", "wing"],
    asset: "wig",
  },
  {
    id: "k3d.obj.log",
    band: "BAND_5_6",
    prompt: { en: "Where is the log?" },
    label: "log",
    audioKey: "k3d.where_is_the_log",
    target: "log",
    choices: ["log", "wing", "rake"],
    asset: "log",
  },
  {
    id: "k3d.obj.twig",
    band: "BAND_5_6",
    prompt: { en: "Where is the twig?" },
    label: "twig",
    audioKey: "k3d.where_is_the_twig",
    target: "twig",
    choices: ["twig", "wing", "rake"],
    asset: "twig",
  },
  {
    id: "k3d.obj.wing",
    band: "BAND_5_6",
    prompt: { en: "Where is the wing?" },
    label: "wing",
    audioKey: "k3d.where_is_the_wing",
    target: "wing",
    choices: ["wing", "rake", "well"],
    asset: "wing",
  },
  {
    id: "k3d.shape.rectangle",
    band: "BAND_5_6",
    prompt: { en: "Where is the rectangle?" },
    label: "rectangle",
    audioKey: "k3d.where_is_the_rectangle",
    target: "rectangle",
    choices: ["rectangle", "star", "heart"],
    asset: "rectangle",
  },
  {
    id: "k3d.shape.star",
    band: "BAND_5_6",
    prompt: { en: "Where is the star?" },
    label: "star",
    audioKey: "k3d.where_is_the_star",
    target: "star",
    choices: ["star", "heart", "oval"],
    asset: "star",
  },
  {
    id: "k3d.shape.heart",
    band: "BAND_5_6",
    prompt: { en: "Where is the heart?" },
    label: "heart",
    audioKey: "k3d.where_is_the_heart",
    target: "heart",
    choices: ["heart", "oval", "diamond"],
    asset: "heart",
  },
  {
    id: "k3d.shape.oval",
    band: "BAND_5_6",
    prompt: { en: "Where is the oval?" },
    label: "oval",
    audioKey: "k3d.where_is_the_oval",
    target: "oval",
    choices: ["oval", "diamond", "square"],
    asset: "oval",
  },
  {
    id: "k3d.shape.diamond",
    band: "BAND_5_6",
    prompt: { en: "Where is the diamond?" },
    label: "diamond",
    audioKey: "k3d.where_is_the_diamond",
    target: "diamond",
    choices: ["diamond", "circle", "square"],
    asset: "diamond",
  },
  {
    id: "k3d.col.black.balloon",
    band: "BAND_5_6",
    prompt: { en: "Where is the black balloon?" },
    label: "black balloon",
    audioKey: "k3d.where_is_the_black_balloon",
    target: "black-balloon",
    choices: ["black-balloon", "red-balloon", "blue-balloon"],
    asset: "black-balloon",
  },
  {
    id: "k3d.col.black.ball",
    band: "BAND_5_6",
    prompt: { en: "Where is the black ball?" },
    label: "black ball",
    audioKey: "k3d.where_is_the_black_ball",
    target: "black-ball",
    choices: ["black-ball", "red-ball", "blue-ball"],
    asset: "black-ball",
  },
  {
    id: "k3d.col.white.balloon",
    band: "BAND_5_6",
    prompt: { en: "Where is the white balloon?" },
    label: "white balloon",
    audioKey: "k3d.where_is_the_white_balloon",
    target: "white-balloon",
    choices: ["white-balloon", "red-balloon", "blue-balloon"],
    asset: "white-balloon",
  },
  {
    id: "k3d.col.white.ball",
    band: "BAND_5_6",
    prompt: { en: "Where is the white ball?" },
    label: "white ball",
    audioKey: "k3d.where_is_the_white_ball",
    target: "white-ball",
    choices: ["white-ball", "red-ball", "blue-ball"],
    asset: "white-ball",
  },
];
